import { render, staticRenderFns } from "./credit-card-company-logos.vue?vue&type=template&id=ddcd80da&scoped=true"
import script from "./credit-card-company-logos.vue?vue&type=script&lang=js"
export * from "./credit-card-company-logos.vue?vue&type=script&lang=js"
import style0 from "./credit-card-company-logos.vue?vue&type=style&index=0&id=ddcd80da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcd80da",
  null
  
)

export default component.exports